var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","align":"center","justify":"center"}},[_c('h1',[_vm._v("Manage User")])])],1),_c('UserEditForm',{attrs:{"mode":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }